import React, { useEffect, useState } from 'react';
import App from './App';
import SignIn from './components/SignIn';
import { api } from './services/api';
import StoreApp from './store/StoreApp';
import { SessionProvider } from './session';
import { SignedInUser } from './types';

/**
 * Šta se vidi zavisi od toga ko je prijavljen.
 *
 * Operater dobija svoj ekran, poslovođa svoj objekat — i to onaj koji stoji uz
 * njegov nalog, ne onaj koji je neko upisao u adresu. Ranije je `?mpo=001`
 * otvarao bilo čiju prodaju svakome ko zna šifru.
 *
 * Vozač ovde ne prolazi: njegov ekran radi bez mreže i bez prijavljivanja.
 */
export default function SignedInApp() {
  const [user, setUser] = useState<SignedInUser | null>(null);
  const [checked, setChecked] = useState(false);
  // Server ne odgovara — to NIJE „nisi prijavljen" (analiza 2.0, B2).
  const [nedostupan, setNedostupan] = useState<string | null>(null);
  const [pokusaj, setPokusaj] = useState(0);

  useEffect(() => {
    api.whoAmI()
      .then((u) => { setUser(u); setNedostupan(null); })
      .catch((e) => setNedostupan(e instanceof Error ? e.message : String(e)))
      .finally(() => setChecked(true));
  }, [pokusaj]);

  // Dok se ne zna ko je, ne prikazuje se ništa: pola ekrana pa prijava izgleda
  // kao da je nešto puklo.
  if (!checked) {
    return <div className="signin"><p className="muted">Učitavam…</p></div>;
  }

  if (nedostupan && !user) {
    return (
      <div className="signin">
        <p>Server trenutno ne odgovara, pa se ne zna ko je prijavljen. Prijava nije istekla.</p>
        <p className="muted">{nedostupan}</p>
        <button type="button" onClick={() => setPokusaj((n) => n + 1)}>Pokušaj ponovo</button>
      </div>
    );
  }

  if (!user) {
    return <SignIn onSignedIn={setUser} />;
  }

  const signOut = () => {
    api.logout().catch(() => undefined).finally(() => setUser(null));
  };

  return (
    <SessionProvider user={user}>
      {user.erpUnavailable && (
        <div className="health health--bad">
          ERP trenutno ne odgovara — prijava važi, ali spiskovi koji čitaju iz ERP-a mogu da
          budu prazni ili zastareli dok se veza ne vrati.
        </div>
      )}
      {/* Zaboravljena migracija je do 16.10.2026. izgledala kao pad ERP-a (K22). */}
      {(user.migracijeFale ?? 0) > 0 && (
        <div className="health health--bad">
          Baza aplikacije nije ažurirana — posle nove verzije nije pokrenuta migracija
          ({user.migracijeFale}). Delovi aplikacije javljaju grešku, i to <strong>nije</strong> pad
          ERP-a. Javi da se pokrene skripta migracije.
        </div>
      )}
      {user.role === 'StoreManager' && user.storeCode
        ? <StoreApp code={user.storeCode} onSignOut={signOut} />
        : <App onSignOut={signOut} />}
    </SessionProvider>
  );
}
